// src/app/core/guards/pyetesori.guard.ts

import { inject } from '@angular/core';
import { CanMatchFn } from '@angular/router';
import { PermissionService } from '@core/services/permission.service';
import { guardWithProfile } from './guard.utils';

/**
 * CanMatchFn — gates the entire /pyetesori section. Requires the
 * `pyetesori.view` portal permission (admin.full_access bypasses
 * via PermissionService.has).
 */
export const pyetesoriGuard: CanMatchFn = () => {
  const perm = inject(PermissionService);
  return guardWithProfile(() => perm.canViewPyetesori(), '/dashboard');
};
